import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class FinancialSummaryService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getSummaryFinancialMonthly(params: {
    startDate: string;
    endDate: string;
    accountId?: string;
    document?: string;
    userId?: string;
  }): Observable<any> {
    let queryParams = new HttpParams()
      .set('startDate', params.startDate)
      .set('endDate', params.endDate);

    if (params.accountId) queryParams = queryParams.set('accountId', params.accountId);
    if (params.document) queryParams = queryParams.set('document', params.document);
    if (params.userId) queryParams = queryParams.set('userId', params.userId);

    return this.http.get<any>(this.url('/summaryFinancialMontly'), {
      params: queryParams,
    });
  }

  getSummaryFinancial(params: {
    startDate: string;
    endDate: string;
    page: number;
    pageSize: number;
    accountId?: string;
    document?: string;
    userId?: string;
  }): Observable<any> {
    let queryParams = new HttpParams()
      .set('startDate', params.startDate)
      .set('endDate', params.endDate)
      .set('pageSize', params.pageSize)
      .set('page', params.page);

    if (params.accountId) queryParams = queryParams.set('accountId', params.accountId);
    if (params.document) queryParams = queryParams.set('document', params.document);
    if (params.userId) queryParams = queryParams.set('userId', params.userId);

    return this.http.get<any>(this.url('/summaryFinancial'), {
      params: queryParams,
    });
  }

  exportSummaryFinancialPdf(params: {
    startDate: string;
    endDate: string;
    accountId?: string;
    document?: string;
    userId?: string;
  }): Observable<any> {
    const payload: any = {
      startDate: params.startDate,
      endDate: params.endDate,
    };

    if (params.accountId) payload.accountId = params.accountId;
    if (params.document) payload.document = params.document;
    if (params.userId) payload.userId = params.userId;

    return this.http.post<any>(this.url('/reports/summary-financial'), payload);
  }
}